import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Define theme with XGC Labs branding color palette from screenshots
const theme = extendTheme({
  colors: {
    xgc: {
      bg: "#000000",
      bgPattern: "#061806",
      primary: "#1EDC0B",
      accent: "#1EDC0B",
      text: "#FFFFFF",
      textSecondary: "#BBBBBB",
    },
  },
  styles: {
    global: {
      body: {
        bg: "#000000",
        color: "#FFFFFF",
        fontFamily: 'Montserrat, system-ui, sans-serif',
      },
      '*::selection': {
        bg: 'rgba(30, 220, 11, 0.3)',
      },
      '.chakra-button': {
        transition: 'all 0.3s ease-in-out',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        borderRadius: "6px",
        _focus: {
          
        },
      },
      variants: {
        solid: {
          bg: "#1EDC0B",
          color: "#000000",
          _hover: {
            bg: "#18B909",
            boxShadow: "0 0 15px rgba(30, 220, 11, 0.5)",
            transform: "translateY(-2px)",
          },
          _active: {
            bg: "#15A308",
          },
        },
        outline: {
          borderColor: "#1EDC0B",
          color: "#1EDC0B",
          _hover: {
            bg: "rgba(30, 220, 11, 0.1)",
            boxShadow: "0 0 15px rgba(30, 220, 11, 0.3)",
          },
        },
        ghost: {
          _hover: {
            bg: "rgba(30, 220, 11, 0.1)",
          },
          _active: {
            bg: "rgba(30, 220, 11, 0.2)",
          },
        },
      },
    },
  },
});

// Force test mode OFF to ensure we try the real SDK flow.
window.ENABLE_XAMAN_TEST_MODE = false;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // React.StrictMode disabled to prevent double XUMM payload creation in development
  // <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
